import { render, staticRenderFns } from "./StoreroomSearchBarComponent.vue?vue&type=template&id=1b2115c6"
import script from "./StoreroomSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./StoreroomSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./StoreroomSearchBarComponent.vue?vue&type=style&index=0&id=1b2115c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports